import { ConfigType } from '@shared/config/types';

/**
 * Filtering to only allowed config entries to stop injecting custom configuration, e.g. utiqHost
 * @param clientConfig - customized configuration st by the customer
 */
export const filterConfig = (clientConfig: ConfigType) => ({
  /* General */
  ...(clientConfig.customUtiqHost && {
    customUtiqHost: clientConfig.customUtiqHost,
  }),
  ...(clientConfig.CMP && {
    CMP: clientConfig.CMP,
  }),
  ...(clientConfig.variation && {
    variation: clientConfig.variation,
  }),
  ...(clientConfig.customizationCSS && {
    customizationCSS: clientConfig.customizationCSS,
  }),
  ...(clientConfig.customizationOptions && {
    customizationOptions: clientConfig.customizationOptions,
  }),
  ...(clientConfig.integrations && {
    integrations: clientConfig.integrations,
  }),
  ...(clientConfig.language && {
    language: clientConfig.language,
  }),
  ...(clientConfig.getNewConsentBeforeExpiry === false && {
    getNewConsentBeforeExpiry: clientConfig.getNewConsentBeforeExpiry,
  }),
  ...(clientConfig.connectionEligibilityRetryInterval && {
    connectionEligibilityRetryInterval:
      clientConfig.connectionEligibilityRetryInterval,
  }),
  ...(clientConfig.logLevel && {
    logLevel: clientConfig.logLevel,
  }),

  /* Consent manager */
  ...(clientConfig.consentManagerOrigin && {
    consentManagerOrigin: clientConfig.consentManagerOrigin,
  }),
  ...(clientConfig.consentManagerDataLayer && {
    consentManagerDataLayer: clientConfig.consentManagerDataLayer,
  }),
  /* Optanon/OneTrust */
  ...(clientConfig.cmpUtiqPurposeId &&
    clientConfig.CMP === 'Optanon' && {
      cmpUtiqPurposeId: clientConfig.cmpUtiqPurposeId,
    }),
  ...(clientConfig.cmpUtiqVendorId &&
    clientConfig.CMP === 'Optanon' && {
      cmpUtiqVendorId: clientConfig.cmpUtiqVendorId,
    }),
  /* Didomi */
  ...(clientConfig.didomiUtiqPurposeId &&
    clientConfig.CMP === 'Didomi' && {
      didomiUtiqPurposeId: clientConfig.didomiUtiqPurposeId,
    }),
  ...(clientConfig.didomiUtiqVendorId &&
    clientConfig.CMP === 'Didomi' && {
      didomiUtiqVendorId: clientConfig.didomiUtiqVendorId,
    }),
});
